module.exports = __webpack_public_path__ + "img/headerLogo2.0b903e5b.png";